<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{params.title}}</div>
    <div slot="body">
      <template v-if="params.provider === 'huawei'">
        <div>
          <p>{{$t('common_422')}}<span class="text-warning">{{$t('cloudenv.text_156')}}</span>{{$t('common_423')}}</p>
          <p>{{$t('common_424')}}</p>
          <p>{{$t('common_425')}}</p>
          <p>{{$t('common_471')}}<span class="text-warning">{{$t('bill.text_30')}}</span>{{$t('common_472')}}</p>
          <p>{{$t('common_473')}}</p>
          <p>{{$t('common_474')}}<span class="text-warning">{{$t('common_475', [ huawei_deposit ])}}</span>。</p>
        </div>
      </template>
      <template v-if="params.provider === 'google'">
        <div>
          <p>{{$t('common_422')}}<span class="text-warning">Google Cloud Platform (GCP) </span>{{$t('common_423')}}</p>
          <p>{{$t('common_476')}}</p>
          <p>{{$t('common_477')}}</p>
          <p>{{$t('common_478')}}<a-select v-model="currency" style="width: 120px">
              <a-select-option value="CNY">{{$t('bill.text_30')}}</a-select-option>
              <a-select-option value="USD">{{$t('scope.text_469')}}</a-select-option>
            </a-select>
          </p>
          <p>{{$t('common_479')}}</p>
        </div>
      </template>
      <template v-if="params.provider === 'aws'">
        <div>
          <p>{{$t('common_422')}}<span class="text-warning">{{$t('common_580')}}</span>{{$t('common_581')}}</p>
          <p>{{$t('common_582')}}</p>
          <p>{{$t('common_583')}}</p>
          <p>{{$t('common_478')}}<a-select v-model="currency" style="width: 120px">
              <a-select-option value="CNY">{{$t('bill.text_30')}}</a-select-option>
              <a-select-option value="USD">{{$t('scope.text_469')}}</a-select-option>
            </a-select>
          </p>
          <p>{{$t('common_584')}}</p>
        </div>
      </template>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{$t('common_480')}}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import { mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'VendorOpenDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      huawei_deposit: 0,
      currency: 'USD',
    }
  },
  computed: {
    ...mapState('app', {
      customer: state => state.customer,
    }),
  },
  created () {
    if (this.params.provider === 'huawei') {
      this.fetchHuaweiDeposit()
    }
  },
  methods: {
    async fetchHuaweiDeposit (id) {
      const { data } = await new this.$Manager('customers').getSpecific({ id: this.customer.id, spec: 'metadata' })
      if (!R.isEmpty(data)) {
        const { huawei_deposit } = JSON.parse(data.__billing_profile__)
        this.huawei_deposit = huawei_deposit
      }
    },
    doOpen (data) {
      return new this.$Manager('cloudsupplier_customers').create({ data })
    },
    async handleConfirm () {
      this.loading = true
      try {
        this.loading = true
        const data = {
          customer_id: this.customer.id,
          provider: this.params.data[0].cloudsupplier,
        }
        if (this.params.provider === 'google' || this.params.provider === 'aws') data.paid_currency = this.currency
        if (this.params.provider === 'aws' && !this.customer.email) {
          this.$message.warning(this.$t('common_585'))
          this.loading = false
          return
        }
        await this.doOpen(data)
        this.loading = false
        this.$message.success(this.$t('scope.text_565'))
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import "~@/styles/less/theme";

.action {
  margin-top: 20px;
  margin-left: 20px;
  color: #666;
  font-size: 12px;
  .success-text {
    color: @success-color;
  }
  .opening-text {
    color: @warning-color;
  }
}
</style>
